import { render, staticRenderFns } from "./index.vue?vue&type=template&id=954f533c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=954f533c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954f533c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('954f533c')) {
      api.createRecord('954f533c', component.options)
    } else {
      api.reload('954f533c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=954f533c&scoped=true", function () {
      api.rerender('954f533c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/multipleSignRecords/index.vue"
export default component.exports